// Demo branch intentionally contains no production transport targets.
export const BASE_URL = "";
export const socketBaseUrl = "";

export const API_ENDPOINTS = {
  gameConfig: `${BASE_URL}/api/games/gameconfig/getconfig`,
  roundResults: `${BASE_URL}/api/rounds/list/getallroundsresult`,
} as const;
